import withExtensions from './withExtensions';

export * from './selectors';
export default withExtensions;



// WEBPACK FOOTER //
// ./src/app/extensions/index.js